import { GetObjectResultsDto } from '../../../../api/generated';
import * as Styled from './ChannelResult.styled';
import { ChannelResultTable } from './ChannelResultTable/ChannelResultTable';
import { ResultArea } from './ResultArea/ResultArea';

export const ChannelResult = ({ data }: { data: GetObjectResultsDto }) => {
  return (
    <Styled.Wrapper>
      <ResultArea data={data} />
      <ChannelResultTable data={data} />
    </Styled.Wrapper>
  );
};
